<app-nav></app-nav>
<section class="add-insurances">
  <div class="container">
    <div class="col">
      <div class="col top-gap-md">
        <div class="input-group">
          <div class="input-group addon">
            <input type="text" class="form-control" placeholder="Patient">
            <span class="input-group-addon" id="basic-addon1"><img src="assets/images/greencheckmark.png"></span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="input-group">
          <div class="input-group addon">
            <input type="text" class="form-control" placeholder="Doctor">
            <span class="input-group-addon" id="basic-addon1"><img src="assets/images/greencheckmark.png"></span>
          </div>
        </div>
      </div>
      <div class="col">
        <div class="input-group">
          <div class="input-group addon">
            <input type="text" class="form-control" placeholder="Appointment Date">
            <span class="input-group-addon" id="basic-addon1"><img src="assets/images/greencheckmark.png"></span>
          </div>
        </div>
      </div>

      <div class="row top-gap-sm">
        <div class="col text-center">
          <img src="assets/images/cameraicon.png" width="50">
        </div>
        <div class="col text-center">
          <img src="assets/images/attachmenticon.png" width="50">
        </div>
      </div>
      <div class="col divider"></div>
      <div class="row text-center top-gap-md">
        <div class="col">
          <h4 class="title">Add Reminder</h4>
        </div>
      </div>
      <div class="col divider"></div>
      <div class="row top-gap-xs">
        <div class="col">
          <label>Remind me until</label>
        </div>
      </div>
      <div class="row top-gap-xs">
        <div class="col">
          <div class="input-group">
            <div class="input-group addon">
              <input type="Date" class="form-control" placeholder="Date">
              <span class="input-group-addon" id="basic-addon1"><img src="assets/images/greencheckmark.png"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col divider"></div>
      <div class="row top-gap-xs">
        <div class="col">
          <label>Repeat weekly</label>
        </div>
      </div>
      <div class="row top-gap-xs repeat-weekly-reminder">
        <div class="col">
          <label>S</label>
          <label>M</label>
          <label>T</label>
          <label>W</label>
          <label>T</label>
          <label>F</label>
          <label>S</label>
        </div>
      </div>
      <div class="col divider"></div>
      <div class="row top-gap-md">
        <div class="col text-left">
          <label>Times a day</label>
        </div>
        <div class="col text-right">
          <label><i class="fa fa-chevron-right"></i></label>
        </div>
      </div>
      <div class="col divider"></div>
      <div class="row text-center top-gap-md bottom-gap-md">
        <div class="col">
          <button class="btn btn-common">Cancel</button>
        </div>
        <div class="col">
          <button class="btn btn-common">Save</button>
        </div>
      </div>
    </div>
  </div>
</section>